import {Helmet} from 'react-helmet';
import Contact from "../../Page/contact";



const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Do you offer website design services in Vadodara?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide expert website design, development, SEO, and e-commerce solutions tailored for businesses in Vadodara."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of website development in Vadodara?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our website development pricing starts from ₹10,000. The total cost varies depending on design, features, and number of pages."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be mobile responsive?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. All websites we design are mobile-friendly and optimized for a seamless experience across all devices."
      }
    },
    {
      "@type": "Question",
      "name": "Is SEO included in your web design service?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, our websites include basic on-page SEO such as meta tags, clean URLs, fast loading speed, alt tags, and schema markup."
      }
    },
    {
      "@type": "Question",
      "name": "Can I edit website content myself after launch?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, your website will be built using a CMS like WordPress, enabling you to easily update content, images, and blogs."
      }
    },
    {
      "@type": "Question",
      "name": "Do you build e-commerce websites in Vadodara?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we develop custom e-commerce websites with product listings, shopping cart, secure checkout, and payment gateway integration."
      }
    },
    {
      "@type": "Question",
      "name": "How much time does it take to create a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A basic business website typically takes 5–10 working days. E-commerce or advanced websites may take 2–4 weeks."
      }
    },
    {
      "@type": "Question",
      "name": "Do you help with domain name and hosting setup?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we help with domain registration, hosting setup, SSL installation, and setting up professional email accounts."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide website maintenance after launch?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we offer maintenance packages that include regular updates, backups, performance optimization, and technical support."
      }
    },
    {
      "@type": "Question",
      "name": "How can I start a website project with you in Vadodara?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Simply contact us through our website or phone. We will understand your requirements and begin the development process."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Pankaj | Website Designer In Vadodara</title>
<meta name="description" content="Top website designer in Vadodara. Get a modern website design with me in low cost. Elevate your online presence today!"/>
<meta name="keywords" content="vadodara web design company, web development company in vadodara, website designer in vadodara, web designer in vadodara, website development in vadodara, website developer in vadodara, website development company vadodara, best web design company in vadodara, web developer in vadodara, website developer near me"/>
<meta property="og:title" content="Pankaj | Website Designer In Vadodara" />
<meta property="og:description" content="Top Website Designer In Vadodara. Get a modern website design with me in low cost. Elevate your online presence today!" />
<meta property="og:site_name" content="Pankaj | Website Designer In Vadodara" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-vadodara"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj | Website Designer In Vadodara" />
<meta name="twitter:description" content="Top website designer in Vadodara. Get a modern website design with me in low cost. Elevate your online presence today!" />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-vadodara" />
        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/bg.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
  <h1 className="multiple_effects fzsml" id="text3d">Website Designer in Vadodara</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/pks2.webp" alt="Website Designer" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

    <main id="main">
  <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Website Designer in Vadodara</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
Are you in search of an innovative and skilled website designer in Vadodara? You’ve come to the right place! I’m Pankaj, a professional website designer committed to creating visually appealing and highly functional websites that elevate your online presence and drive your business growth.
<h3>Why Choose Pankaj for Your Website Design?</h3>
<ol>
  <li><strong>Tailored Designs That Represent Your Brand</strong>
With years of experience in website design, I focus on creating custom solutions that reflect your brand’s unique identity. Whether you need a sophisticated corporate site, a vibrant e-commerce platform, or a personal blog, I ensure that your website not only looks great but also serves its intended purpose.</li>
  <li><strong>SEO-Optimized for Enhanced Visibility</strong>
I understand that a beautiful website must be discoverable. My designs include essential SEO practices to help your site rank higher on search engines like Google, increasing your visibility and attracting more potential customers.</li>
  <li><strong>Comprehensive Website Design Services</strong>
I offer a wide array of services, including website development, redesigns, and e-commerce solutions. My expertise with popular CMS platforms such as WordPress allows you to manage your content easily after your site is launched.</li>
  <li><strong>Transparent Pricing and Ongoing Support</strong>
I believe in clear communication and providing transparent pricing. After discussing your project requirements, I’ll present a detailed quote so you know exactly what to expect. My dedication to client satisfaction means I’m here to assist you even after your website goes live.</li>
</ol>
<h3>Services Offered</h3>
<ul>
  <li><strong>Custom Website Design &amp; Redesign</strong>
Unique, modern designs tailored to align with your brand identity, enhancing user engagement and functionality.</li>
  <li><strong>E-commerce Website Development</strong>
Secure and user-friendly e-commerce platforms designed to optimize conversions and provide a seamless shopping experience for your customers.</li>
  <li><strong>Corporate and Personal Websites</strong>
Professionally designed websites that effectively showcase your business or personal projects, engaging visitors and clearly conveying your goals.</li>
  <li><strong>SEO and Digital Marketing Services</strong>
Basic SEO practices included in all designs, with options for advanced strategies through collaboration with trusted marketing partners.</li>
</ul>
<h3>Get Started Today</h3>
Are you ready to enhance your online presence? Contact me today to discuss your vision, and let’s work together to create a website that truly represents your brand in the digital landscape.
<h2>Frequently Asked Questions</h2>

<h4>What types of websites can Pankaj design in Vadodara?</h4>
<p>Pankaj specializes in designing a variety of websites, including corporate sites, e-commerce platforms, personal blogs, and portfolios. Each website is customized to meet the specific needs and goals of the client.</p>

<h4>Why should I choose Pankaj as my website designer?</h4>
<p>Pankaj offers high-quality, responsive, and SEO-friendly websites crafted with attention to detail. His extensive experience ensures that each project effectively communicates your brand identity while providing a seamless user experience.</p>

<h4>Does Pankaj provide SEO services for my website?</h4>
<p>Yes, Pankaj incorporates basic SEO practices in all his website designs to enhance visibility on search engines. For more advanced SEO strategies, he can collaborate with trusted partners who specialize in digital marketing.</p>

<h4>How much does it cost to design a website with Pankaj?</h4>
<p>The cost of designing a website depends on several factors, including the project's complexity, the number of pages, and any additional features you may want. Pankaj provides project-specific quotes after discussing your requirements and budget.</p>

<h4>Can I update my website content after it’s launched?</h4>
<p>Absolutely! Pankaj builds websites using user-friendly CMS platforms like WordPress, allowing you to easily manage and update your content once the site is live. He also provides training and documentation to help you navigate updates.</p>

<h4>What if I need help with my website after it’s live?</h4>
<p>Pankaj offers ongoing maintenance and support for all his clients. This includes troubleshooting, updates, and performance improvements to ensure your website remains secure and effective over time.</p>

<h4>How long does it take to complete a website design project?</h4>
<p>The timeline for completing a website design project varies based on its complexity and specific requirements. After discussing your project, Pankaj will provide a realistic timeline, which typically ranges from a few weeks to a couple of months.</p>

<h4>How can I get in touch with Pankaj for my website design project?</h4>
<p>You can reach out to Pankaj through the contact form on this website or by using the provided contact information. He will be happy to discuss your project and help you create a website that meets your needs.</p>


          </div>
        </div>
      </div>

    </section>
 <Contact />
    </main>
    </>
  );
}
export default App1;
